import { NavRoute } from 'models/routes';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { MAIN_THEME } from 'styles/colors';
import Icon from './Icon';

interface Props {
	route: NavRoute;
	isActive: boolean;
	isExpanded: boolean;
}

interface IconWrapProps {
	isExpanded: boolean;
}

const RouteBase = styled(NavLink)`
	height: 48px;
	width: 100%;
	display: flex;
	background-color: transparent;
	align-items: center;
	color: ${MAIN_THEME.TEXT_SECONDARY};
	font-size: 18px;
	text-decoration: none;
	border-radius: 10px;
	transition: background 0.15s ease, color 0.15s ease;

	&.active {
		background: ${MAIN_THEME.DARK_BG_TERTIARY};
		color: ${MAIN_THEME.TEXT_PRIMARY};
	}

	&:hover {
		background: ${MAIN_THEME.DARK_BG_TERTIARY};
	}

	&.active:hover {
		background: ${MAIN_THEME.DARK_BG_TERTIARY};
		color: ${MAIN_THEME.TEXT_PRIMARY};
	}

	@media (max-width: 768px) {
		height: 50px;
		width: auto;
		flex: 1;
		justify-content: center;
		padding: 0 8px;
		border-radius: 8px;
		font-size: 12px;
	}

	@media (max-width: 480px) {
		padding: 0 5px;
	}
`;

const Route = styled(RouteBase)`
	justify-content: center;
`;

const ExtendedRoute = styled(RouteBase)`
	padding: 0 30px;

	@media (max-width: 768px) {
		padding: 0 8px;
	}
`;

const IconWrap = styled.div<IconWrapProps>`
	margin-right: ${(props) => (props.isExpanded ? '30px' : 0)};

	@media (max-width: 768px) {
		margin-right: 0;
	}
`;

const NavbarRoute = (props: Props): JSX.Element => {
	const { route, isExpanded } = props;

	const renderRouteContent = () => (
		<>
			{route.icon ? (
				<IconWrap isExpanded={isExpanded}>
					<Icon
						name={route.icon}
						size={window.innerWidth <= 768 ? 20 : 30}
						color="currentColor"
					/>
				</IconWrap>
			) : null}
			{isExpanded && window.innerWidth > 768 ? route.title : null}
		</>
	);

	const renderRoute = () =>
		isExpanded ? (
			<ExtendedRoute key={route.to} to={route.to}>
				{renderRouteContent()}
			</ExtendedRoute>
		) : (
			<Route key={route.to} to={route.to}>
				{renderRouteContent()}
			</Route>
		);

	return renderRoute();
};

export default NavbarRoute;
